import { useParams } from "react-router-dom";
import OfferList from "./List.jsx";
import OfferDetail from "./Detail.jsx";

const OffersPage = () => {
    const { secondParam } = useParams();

    const Specified = secondParam ? OfferDetail : OfferList;

    return <Specified />;
};

export default OffersPage;
